import React from 'react';
import './DeliveryStatus.css';

const DeliveryStatus = ({ 
  message, 
  currentUserId, 
  isOwnMessage = false,
  showTooltip = true 
}) => {
  if (!isOwnMessage || !message) {
    return null;
  }

  const getDeliveryStatus = () => {
    const delivery = message.delivery || {};
    const sentAt = delivery.sentAt;
    const deliveredTo = delivery.deliveredTo || [];
    const readBy = delivery.readBy || [];
    
    // Check if message is sent
    if (!sentAt) {
      return { status: 'sending', icon: '⏳', color: 'rgba(255, 255, 255, 0.7)' };
    }
    
    // Fallback: if no delivery data, show as sent
    if (!delivery || Object.keys(delivery).length === 0) {
      return { status: 'sent', icon: '✓', color: 'rgba(255, 255, 255, 0.7)', tooltip: 'Sent' };
    }
    
    // For DM rooms, we expect 1 recipient (the other person)
    // For group rooms, we need to calculate total recipients
    const totalRecipients = message.totalRecipients || (deliveredTo.length > 0 ? deliveredTo.length : 1);
    const readCount = readBy.length;
    const deliveredCount = deliveredTo.length;
    
    // Check if all recipients have read the message
    if (readCount > 0 && readCount >= totalRecipients) {
      return { 
        status: 'read', 
        icon: '✓✓', 
        color: '#0099FF', // Blue color for read receipts
        tooltip: `Read by all ${totalRecipients} recipient${totalRecipients > 1 ? 's' : ''}`
      };
    }
    
    // Check if some recipients have read the message (but not all)
    if (readCount > 0) {
      return { 
        status: 'read-partial', 
        icon: '✓✓', 
        color: '#4FC3F7', // Light blue for partial read
        tooltip: `Read by ${readCount}/${totalRecipients} recipients`
      };
    }
    
    // Check if all recipients have received the message (but not all have read)
    if (deliveredCount > 0 && deliveredCount >= totalRecipients) {
      return { 
        status: 'delivered', 
        icon: '✓✓', 
        color: 'rgba(255, 255, 255, 0.8)',
        tooltip: `Delivered to all ${totalRecipients} recipient${totalRecipients > 1 ? 's' : ''}`
      };
    }
    
    // Check if some recipients have received the message
    if (deliveredCount > 0) {
      return { 
        status: 'delivered-partial', 
        icon: '✓✓', 
        color: 'rgba(255, 255, 255, 0.7)',
        tooltip: `Delivered to ${deliveredCount}/${totalRecipients} recipients`
      };
    }
    
    // Message is sent but not delivered to anyone
    return { 
      status: 'sent', 
      icon: '✓', 
      color: 'rgba(255, 255, 255, 0.7)',
      tooltip: 'Sent'
    };
  };

  const deliveryInfo = getDeliveryStatus();

  return (
    <div 
      className={`delivery-status ${deliveryInfo.status}`}
      style={{ color: deliveryInfo.color }}
      title={showTooltip ? deliveryInfo.tooltip : ''}
    >
      <span className="delivery-icon">{deliveryInfo.icon}</span>
      {deliveryInfo.status === 'delivered-partial' && (
        <span className="delivery-count">
          {message.delivery?.deliveredTo?.length || 0}/{message.totalRecipients || 0}
        </span>
      )}
    </div>
  );
};

export default DeliveryStatus;
